import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacings.xs};

  & > *:nth-child(1) {
    flex: 4 0 250px;
  }

  & > *:nth-child(2) {
    flex: 0 0 100px;
  }
`;
